// The lease link capture must be the very first import: it runs when imported, before the router, the store's
// first render and the analytics tracker exist (contract section 8.1).
import { captureLeaseLink } from './leaseLink';
import React, { useLayoutEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './reduxStore';
import { Provider } from 'react-redux';
import { BrowserRouter, useLocation } from 'react-router-dom';

captureLeaseLink();

const Wrapper = ({ children }: any) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <BrowserRouter>
      <Wrapper>
        <Provider store={store}>
          <App />
        </Provider>
      </Wrapper>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
